import { useLang } from "@/context/LangContext";

export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div
      role="group"
      aria-label="Language"
      data-testid="lang-toggle"
      className={`inline-flex items-center rounded-full border border-white/15 bg-white/[0.04] p-0.5 ${className}`}
    >
      {["en", "es"].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          data-testid={`lang-toggle-${l}`}
          className={`px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-[0.14em] transition-colors ${
            lang === l ? "bg-white text-black" : "text-white/55 hover:text-white"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
